import React, {useEffect, useState} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import GuideModal from "../buildingPages/modals/GuideModal";
import GuideVideoModal from "../buildingPages/modals/GuideVideoModal";

const Sidebar = () => {
  const [isGuideModalOpen, setIsGuideModalOpen] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [initialImageIndex, setInitialImageIndex] = useState(0);

  const location = useLocation();
  const navigate = useNavigate();

  const isSelected = (path) => location.pathname === path;
  const role = sessionStorage.getItem("role");

  useEffect(() => {
    const path = location.pathname;
    let tutorialShownKey = '';

    if (isSelected("/building-list") || isSelected("/admin")) {
      tutorialShownKey = 'tutorialShownBuildingList';
      setInitialImageIndex(0);
    } else if (isSelected("/electricity")) {
      tutorialShownKey = 'tutorialShownElectricity';
      setInitialImageIndex(2);
    } else if (isSelected("/water")) {
      tutorialShownKey = 'tutorialShownWater';
      setInitialImageIndex(3);
    } else if (isSelected("/bill")) {
      tutorialShownKey = 'tutorialShownBill';
      setInitialImageIndex(4);
    }

    // 첫 방문인지 확인하고 튜토리얼 비디오 모달 열기
    // if (!localStorage.getItem("videoTutorialShown")) {
    //   setIsVideoModalOpen(true);
    //   localStorage.setItem("videoTutorialShown", "true");
    // }

    // 첫 방문인지 확인
    if (tutorialShownKey && !localStorage.getItem(tutorialShownKey)) {
      setIsGuideModalOpen(true);
      localStorage.setItem(tutorialShownKey, 'true');
    }
  }, [location.pathname]);

  const icons = {
    buildingList: isSelected("/building-list") || isSelected("/admin") ? "/infoCatHover.png" : "/infoCat.png",
    electricity: isSelected("/electricity") ? "/elecCatHover.png" : "/elecCat.png",
    water: isSelected("/water") ? "/waterCatHover.png" : "/waterCat.png",
    billing: isSelected("/bill") ? "/billingCatHover.png" : "/billingCat.png",
  };

  const handleSideLogoClick = () => {
    navigate("/building-list");
  };

  const handleGuideClick = () => {
    let imageIndex = 0;
    if (isSelected("/building-list") || isSelected("/admin")) {
      imageIndex = 0;  // 건물 정보 설명서 첫 이미지
    } else if (isSelected("/electricity")) {
      imageIndex = 2;  // 전기세 계산 설명서 첫 이미지
    } else if (isSelected("/water")) {
      imageIndex = 3;  // 수도세 계산 설명서 첫 이미지
    } else if (isSelected("/bill")) {
      imageIndex = 4;  // 청구 설명서 첫 이미지
    }
    setInitialImageIndex(imageIndex);
    setIsGuideModalOpen(true);
  };

  const handleVideoClick = () => {
    setIsVideoModalOpen(true);
  };

  return (
    <div className="sidebar">
      <img 
        src="/sidebarLogo.png" 
        alt="Cleanier-building" 
        className="sidebar-logo" 
        onClick={handleSideLogoClick}/>
      <div className="category-bar">
        <Link
            to={role === "ADMIN" ? "/admin" : "/building-list"}
            className={`nav-buildinglist-button ${isSelected("/building-list") || isSelected("/admin") ? "selected" : ""}`}
        >
          <img src={icons.buildingList} alt="Information Category" className="info-icon" />
          건물 정보
        </Link>
        <Link to="/electricity" className={`nav-electricity-button ${isSelected("/electricity") ? "selected" : ""}`}>
          <img src={icons.electricity} alt="Electricity Category" className="elec-icon" />
          전기세 계산
        </Link>
        <Link to="/water" className={`nav-water-button ${isSelected("/water") ? "selected" : ""}`}>
          <img src={icons.water} alt="Water Category" className="water-icon" />
          수도세 계산
        </Link>
        <Link to="/bill" className={`nav-billing-button ${isSelected("/bill") ? "selected" : ""}`}>
          <img src={icons.billing} alt="billing-category" className="billing-icon" />
          청구
        </Link>
      </div>
      <div className="guide-button-container">
        {/* <button className="video-button" onClick={handleVideoClick}>
          튜토리얼 영상 보기
        </button> */}
        <button className="guide-button" onClick={handleGuideClick}>
          가이드 보기
        </button>
      </div>
      <GuideVideoModal 
        isOpen={isVideoModalOpen} 
        onClose={() => setIsVideoModalOpen(false)} 
      />
      <GuideModal 
        isOpen={isGuideModalOpen} 
        onClose={() => setIsGuideModalOpen(false)} 
        initialImageIndex={initialImageIndex} 
      />
    </div>
  );
};

export default Sidebar;

